const getLowestPrice = (
  adultCount,
  childCount,
  infantCount,
  minorObj,
  pricing
) => {
  let totalGuest = adultCount + childCount + infantCount;

  let adultPricing =
    pricing?.filter((pr) => pr?.adultCount === adultCount)?.[0]?.priceForPax ||
    [];

  let childPricing = minorObj?.children;
  let infantPricng = minorObj?.infants;

  let dates = adultPricing?.map((date) => date?.checkInDate) || [];

  let rpArr = [];

  dates.forEach((date) => {
    let sum = 0,
      tax = 0;

    // calculate adult price
    sum += adultPricing?.filter((dt) => dt?.checkInDate === date)?.[0]
      ?.priceBeforeTax;

    if (childCount > 0) {
      let datePrice = childPricing?.filter((dt) => dt?.checkInDate === date)[0]
        ?.priceBeforeTax;
      let childPrice = 0;
      for (let i = 0; i < childCount; i++) {
        childPrice += datePrice;
      }

      if (pricing?.some((pr) => pr?.adultCount === adultCount + childCount)) {
        let extraAdultComparePrice =
          pricing?.filter(
            (pr) => pr?.adultCount === adultCount + childCount
          )?.[0]?.priceForPax || [];
        let priceForThis = extraAdultComparePrice?.filter(
          (pr) => pr?.checkInDate === date
        )?.[0]?.priceBeforeTax;
        sum = Math.min(priceForThis, sum + childPrice);
      }
    }
    if (infantCount > 0) {
      // compare the price with child and swap it with infant;
      let childDatePrice = childPricing?.filter(
        (dt) => dt?.checkInDate === date
      )[0]?.priceBeforeTax;

      let infantDatePrice = infantPricng?.filter(
        (dt) => dt?.checkInDate === date
      )[0]?.priceBeforeTax;

      let infantPrice = Math.min(childDatePrice, infantDatePrice);
      let price = 0;
      for (let i = 0; i < infantCount; i++) {
        price += infantPrice;
      }

      if (
        pricing?.some(
          (pr) => pr?.adultCount === adultCount + infantCount + childCount
        )
      ) {
        let extraAdultComparePrice =
          pricing?.filter(
            (pr) => pr?.adultCount === adultCount + infantCount + childCount
          )?.[0]?.priceForPax || [];
        let priceForThis = extraAdultComparePrice?.filter(
          (pr) => pr?.checkInDate === date
        )?.[0]?.priceBeforeTax;
        sum = Math.min(priceForThis, sum + price);
      }
    }
    let obj = {
      checkInDate: date,
      priceBeforeTax: sum,
    };
    rpArr.push(obj);
  });

  return rpArr;
};

const getLowestRoomRatePlanPrice = (room, totalAdult, childCount = 0) => {
  const maxGuest =
    totalAdult < room?.maxAdultCount ? totalAdult : room?.maxAdultCount;

  let searchedRooms = distributeGuests(
    parseInt(totalAdult),
    parseInt(childCount),
    room?.availableRooms,
    room?.maxGuestCount,
    maxGuest,
    room?.maxChildCount
  );

  const rpPrices = [];

  if (searchedRooms?.length > 0) {
    Object.keys(room?.ratePlans).forEach((code) => {
      let rpPrice = 0;
      for (let i = 0; i < searchedRooms?.length; i++) {
        let tempArr = getLowestPrice(
          searchedRooms[i]?.adults,
          searchedRooms[i]?.children,
          0,
          room?.pricingAdditionalGuests[code],
          room?.pricing?.filter((r) => r?.ratePlanCode === code)
        );

        tempArr?.forEach((obj) => {
          let tempPrice = obj?.priceBeforeTax;
          rpPrice += tempPrice;
        });
      }
      if (rpPrice > 0) {
        rpPrices.push(rpPrice);
      }
    });
  } else {
    const aCount = totalAdult <= maxGuest ? totalAdult : maxGuest;
    Object.keys(room?.ratePlans).forEach((code) => {
      let tempArr =
        room?.pricing?.filter(
          (pr) =>
            pr?.adultCount === parseInt(aCount) &&
            pr?.childCount === 0 &&
            pr?.infantCount === 0 &&
            pr?.ratePlanCode === code
        )?.[0]?.priceForPax || [];

      let rpPrice = 0;
      tempArr?.forEach((obj, idx) => {
        let tempPrice = obj?.priceBeforeTax;
        rpPrice += tempPrice;
      });
      if (rpPrice > 0) {
        rpPrices.push(rpPrice);
      }
    });
  }

  // return [432,432,432,43]
  // console.log({ room: room.roomName, rpPrices });
  // return Math.min(...rpPrices);
  return {
    lowestPrice: Math.min(...rpPrices),
    canAccomadate: searchedRooms?.length > 0,
  };
};

function distributeGuests(
  totalAdults,
  totalChildren,
  roomQuantity,
  maxGuests,
  maxAdults,
  maxChildren
) {
  let rooms = [];
  let remainingAdults = totalAdults;
  let remainingChildren = totalChildren;
  // return [];

  if (totalChildren > 0 && !maxChildren) {
    return [];
  }

  // Calculate the minimum number of rooms required to accommodate all guests
  let minRoomsNeeded = Math.ceil(totalAdults / maxAdults);
  minRoomsNeeded = Math.max(
    minRoomsNeeded,
    Math.ceil((totalAdults + totalChildren) / maxGuests)
  );

  // If the number of rooms available is less than the minimum required, return an empty array
  if (roomQuantity < minRoomsNeeded) {
    return [];
  }

  for (let i = 0; i < roomQuantity; i++) {
    let roomAdults = 0;
    let roomChildren = 0;

    // Allocate children with at least one adult
    if (remainingChildren > 0 && remainingAdults > 0) {
      roomChildren = Math.min(remainingChildren, maxChildren, maxGuests - 1); // At least one adult must be in the room
      roomAdults = Math.min(
        remainingAdults,
        maxAdults,
        maxGuests - roomChildren
      );

      remainingChildren -= roomChildren;
      remainingAdults -= roomAdults;
    } else if (remainingAdults > 0) {
      roomAdults = Math.min(remainingAdults, maxAdults, maxGuests);
      remainingAdults -= roomAdults;
    }

    rooms.push({ adults: roomAdults, children: roomChildren });

    // If all guests are accommodated, break the loop
    if (remainingAdults === 0 && remainingChildren === 0) {
      break;
    }
  }

  // If there are still remaining adults or children after using all rooms, return an empty array
  if (remainingAdults > 0 || remainingChildren > 0) {
    return [];
  }

  return rooms;
}

export function sortRoomsByPrice({ rooms, adultCount = 2, childCount = 0 }) {
  function getMinPriceBeforeTax(pricingObj) {
    if (!pricingObj) return;
    return Math.min(...pricingObj.priceForPax?.map((p) => p?.priceBeforeTax));
  }
  let availRooms = rooms?.filter((rm) => rm?.availableRooms > 0);
  availRooms.forEach((obj) => {
    obj?.pricing?.sort(
      (a, b) => getMinPriceBeforeTax(a) - getMinPriceBeforeTax(b)
    );
  });

  let nonAvailRooms = rooms?.filter((rm) => rm?.availableRooms === 0);

  //   const adultCount = params?.totalAdult || 2;
  //   const childCount = params?.totalChildren || 0;
  availRooms.sort((a, b) => {
    const aData = getLowestRoomRatePlanPrice(a, adultCount, childCount);
    const bData = getLowestRoomRatePlanPrice(b, adultCount, childCount);

    if (aData?.canAccomadate !== bData?.canAccomadate) {
      return aData?.canAccomadate ? -1 : 1; // true comes first
    }

    return aData?.lowestPrice - bData?.lowestPrice;
  });

  return [...availRooms, ...nonAvailRooms];
}
